import { Tag, Typography } from "antd";
import React from "react";

const { Text } = Typography;
const bizNodeData = {
    'SA_MAP': {
        name: '模型总图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB', 'BAM', 'TAM'],
        color: 'rgb(255, 0, 0)',
        fontColor: '#fff',
    },
    'OA': {
        name: '组织结构',
        dpFlag: '1',
        prjTypeCodes: ['OM'],
        color: 'rgb(255, 255, 153)',
    },
    'ORG_MAP': {
        name: '组织地图',
        dpFlag: '2',
        prjTypeCodes: ['OM'],
        color: 'rgb(255, 255, 153)',
    },
    'OM': {
        name: '组织域',
        dpFlag: '0',
        prjTypeCodes: ['OM'],
        color: 'rgb(255, 255, 153)',
    },
    'OO': {
        name: '组织对象',
        dpFlag: '1',
        prjTypeCodes: ['OM'],
        color: 'rgb(255, 255, 153)',
    },
    'OU': {
        name: '组织单元',
        dpFlag: '0',
        prjTypeCodes: ['OM'],
        color: 'rgb(255, 255, 153)',
    },
    'OR': {
        name: '岗位角色',
        dpFlag: '0',
        prjTypeCodes: ['OM'],
        color: 'rgb(255, 255, 153)',
    },
    'RULEMRM': {
        name: '知识模块',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(244, 151, 83)',
    },
    'RULEMRMRULE': {
        name: '重要规则',
        dpFlag: '0',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(244, 151, 83)',
    },
    'PA': {
        name: '知识结构',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BF_MAP': {
        name: '知识地图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'PM': {
        name: '知识域',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'BA': {
        name: '业务结构',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BIZ_MAP': {
        name: '业务地图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BM': {
        name: '业务域',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BF': {
        name: '业务流程',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BD': {
        // name: '业务能力模块',
        name: '程序模块',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BD_BODA2': {
        name: '程序模块',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    // 'SVR': {
    //     name: '业务服务',
    //     dpFlag: '1',
    //     prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
    //     color: 'rgb(255, 255, 153)',
    // },
    'WF': {
        name: '流程图',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BFDATAFLOW': {
        name: '子流程',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BDTERM': {
        name: '业务术语',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BDSUMMARY': {
        name: '用户场景',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
        // 子类型
        subTypes: {
            'COMMON': '通用',
            'INF': '接口',
            'SYS': '系统',
            'TMPL': '模板',
        }
    },
    'BDRULE': {
        name: '业务规则',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
        // 子类型
        subTypes: {
            'COMMON': '通用',
            'IS': '数据对象',
            'DE': '数据实体',
        }
    },
    'BDEVENT': {
        name: '业务事件',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BDLOGIC': {
        // name: '业务能力模块',
        name: '程序能力',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
        // 子类型
        subTypes: {
            'BT': '交互业务事务能力',
            'INF': '接口业务事务能力',
            'TIME': '定时业务事务能力',
            'BL': '基础业务事务能力',
        }
    },
    'BDLOGIC_BODA2': {
        name: '程序能力',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
        // 子类型
        subTypes: {
            'BT': '交互程序能力',
            'INF': '接口程序能力',
            'TIME': '自动程序能力',
            'BL': '基础程序能力',
        }
    },
    'BDBASE': {
        name: '业务基础方法',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    'BDALG': {
        name: '业务事务方法',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(255, 255, 153)',
    },
    // 基准分析模型
    'AA': {
        name: '分析结构',
        dpFlag: '1',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'ANA_MAP': {
        name: '分析地图',
        dpFlag: '2',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'AM': {
        name: '分析域',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'AO': {
        name: '分析对象',
        dpFlag: '1',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'IE': {
        name: '指标实体',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'AD': {
        name: '分析维度',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'DO': {
        name: '维度对象',
        dpFlag: '1',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'DE': {
        name: '维度实体',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'AMAR': {
        name: '分析报表',
        dpFlag: '1',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'ARRD': {
        name: '报表维度',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'ARRI': {
        name: '报表指标',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'AMAI': {
        name: '分析指标',
        dpFlag: '1',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'AIAC': {
        name: '分析口径',
        prjTypeCodes: ['BAM', 'TAM'],
        color: 'rgb(255, 182, 122)',
    },
    'FA': {
        name: '功能结构',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'SF_MAP': {
        name: '功能地图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'FM': {
        name: '功能域',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'SF': {
        name: '系统功能',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'CA': {
        name: '用例结构',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'UC_MAP': {
        name: '用例地图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'CM': {
        name: '用例域',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'UC': {
        name: '集成用例',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(253, 216, 52)',
    },
    'UA': {
        name: '入口结构',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
    },
    'UI_MAP': {
        name: '界面地图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
    },
    'UM': {
        name: '界面入口',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
    },
    'UI': {
        name: '用户界面',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
    },
    'UV': {
        name: '界面视图',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
        // 子类型
        subTypes: {
            'IMG': '图片',
            'DEMO': '原型',
        }
    },
    'UIRULE': {
        name: '界面规则',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
        // 子类型
        subTypes: {
            'COMMON': '通用',
            'DC': '数据控件',
        }
    },
    'UE': {
        name: '界面事件能力',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
        // 子类型
        subTypes: {
            'INI': '界面初始化',
            'PUA': '父界面能力',
            'OTH': '其他',
        }
    },
    'UIALG': {
        name: '界面基础能力',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(80, 195, 247)',
    },
    'SS': {
        name: '子系统',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'FC_MAP': {
        name: '程序地图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'FC': {
        name: '程序能力',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'DTO': {
        name: 'DTO',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'DTF': {
        name: '属性',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'VM': {
        name: '程序域',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'MID': {
        name: '中间件',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'LS': {
        name: '外联系统',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(186, 105, 200)',
    },
    'LSI': {
        name: '外联接口',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(186, 105, 200)',
    },
    'DB': {
        name: '数据库',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'DATA_MAP': {
        name: '库表地图',
        dpFlag: '2',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'DM': {
        name: '库表域',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'DT': {
        name: '数据表',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'DV': {
        name: '数据视图',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'CDG': {
        name: '标准字段组',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'CDT': {
        name: 'CDT',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB', 'BAM', 'TAM'],
        color: 'rgb(125, 255, 255)',
    },
    'DF': {
        name: '表字段',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'DGF': {
        name: '标准字段',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(125, 255, 255)',
    },
    'CDTSEQVAL': {
        name: '序列值',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB', 'BAM', 'TAM'],
        color: 'rgb(125, 255, 255)',
    },
    'PHYS': {
        name: '物理机',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(0, 100, 0)',
        fontColor: '#fff',
    },
    'VR': {
        name: '虚拟机',
        dpFlag: '1',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(0, 100, 0)',
        fontColor: '#fff',
    },
    'SSINS': {
        name: '子系统实例',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'MIDINS': {
        name: '中间件实例',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'DBINS': {
        name: '数据库实例',
        prjTypeCodes: ['BM', 'NEW', 'ONLINE', 'DM', 'BCT', 'LIB'],
        color: 'rgb(213, 251, 97)',
    },
    'MDM': {
        name: 'MD知识模件',
        dpFlag: '1',
        // 仅用于 MD 知识库引用分析，不参与模型类型筛选
        prjTypeCodes: [],
        color: 'rgb(80, 195, 247)',
    },
}
const sfTypeData = {
    'INF': '接口功能',
    'TIME': '定时功能',
    'UI': '交互业务功能',
    'EXPERIENCE': '体验增强功能',
}

export default function BizNodeTypeTag({ bizNodeType, dpType, subTypeCode, ...props }) {
    let obj = findBizNodeTypeData(bizNodeType, dpType, subTypeCode);

    // 部件子类型
    let subTypeName = ''
    if (dpType) {
        subTypeName = convertToDppSubTypeName(bizNodeType, dpType, subTypeCode);
    }

    if (subTypeName) {
        obj = { ...obj, name: obj.name + ' / ' + subTypeName }
    }

    return (
        <Tag color={obj.color} {...props}><Text style={{ color: obj.fontColor ?? 'black' }}>{obj.name}</Text></Tag>
    );
}

function findBizNodeTypeData(bizNodeType, dpType, subTypeCode) {
    let obj

    if (bizNodeType === 'BD' || bizNodeType === 'SVR') {
        if (dpType) {
            obj = bizNodeData[dpType]
        } else {
            obj = bizNodeData[bizNodeType]
        }

        if ('BODA2' == subTypeCode) {
            obj = bizNodeData['BD_BODA2'];
        }
    } else if (bizNodeType === 'SF') {
        obj = bizNodeData[bizNodeType]
        if (dpType) {
            const subName = sfTypeData[dpType]
            if (subName) {
                obj = { ...obj, name: subName }
            }
        }
    } else {
        if ('BDLOGIC' == bizNodeType && 'BODA2' == subTypeCode) {
            obj = bizNodeData['BDLOGIC_BODA2'];
        } else {
            obj = bizNodeData[bizNodeType];
        }
    }

    return obj ?? { name: bizNodeType + (dpType ? `/${dpType}` : ''), color: 'default' }
}

function convertToBizNodeTypeName(bizNodeType, dpType, subTypeCode) {
    let obj = findBizNodeTypeData(bizNodeType, dpType, subTypeCode)
    return obj.name
}

// 获取部件节点子类型名称
function convertToDppSubTypeName(dppBizNodeType, dppType, subTypeCode) {
    let obj;
    if ('BDLOGIC' == dppBizNodeType && 'BODA2' == subTypeCode) {
        obj = bizNodeData['BDLOGIC_BODA2'];
    } else {
        obj = bizNodeData[dppBizNodeType];
    }

    if (obj && obj.subTypes && obj.subTypes[dppType]) {
        return obj.subTypes[dppType]
    }
    return '';
}

function bizNodeTypeOptions(subTypeCode) {
    let options = []
    for (let bizNodeDataKey in bizNodeData) {
        let addFlag = true;
        if ('BD' == bizNodeDataKey && 'BODA2' == subTypeCode) {
            addFlag = false;
        }
        if ('BD_BODA2' == bizNodeDataKey && !('BODA2' == subTypeCode)) {
            addFlag = false;
        }
        if ('BDLOGIC' == bizNodeDataKey && 'BODA2' == subTypeCode) {
            addFlag = false;
        }
        if ('BDLOGIC_BODA2' == bizNodeDataKey && !('BODA2' == subTypeCode)) {
            addFlag = false;
        }

        let bizNodeDataKeyValue = bizNodeDataKey == 'BD_BODA2' ? 'BD' : bizNodeDataKey;
        bizNodeDataKeyValue = bizNodeDataKeyValue == 'BDLOGIC_BODA2' ? 'BDLOGIC' : bizNodeDataKeyValue;


        if (addFlag) {
            options.push({
                label: bizNodeData[bizNodeDataKey].name, value: bizNodeDataKeyValue,
                dpFlag: bizNodeData[bizNodeDataKey].dpFlag ?? '0',
                prjTypeCodes: bizNodeData[bizNodeDataKey].prjTypeCodes ?? ''
            })
        }
    }
    return options;
}

function subTypeOptions(subTypeCode) {
    let options = []
    for (let bizNodeDataKey in bizNodeData) {
        let addFlag = true;
        if ('BD' == bizNodeDataKey && 'BODA2' == subTypeCode) {
            addFlag = false;
        }
        if ('BD_BODA2' == bizNodeDataKey && !('BODA2' == subTypeCode)) {
            addFlag = false;
        }
        if ('BDLOGIC' == bizNodeDataKey && 'BODA2' == subTypeCode) {
            addFlag = false;
        }
        if ('BDLOGIC_BODA2' == bizNodeDataKey && !('BODA2' == subTypeCode)) {
            addFlag = false;
        }

        let bizNodeDataKeyValue = bizNodeDataKey == 'BD_BODA2' ? 'BD' : bizNodeDataKey;
        bizNodeDataKeyValue = bizNodeDataKeyValue == 'BDLOGIC_BODA2' ? 'BDLOGIC' : bizNodeDataKeyValue;


        if (addFlag) {
            options.push({
                label: bizNodeData[bizNodeDataKey].name, value: bizNodeDataKeyValue,
                dpFlag: bizNodeData[bizNodeDataKey].dpFlag ?? '0',
                prjTypeCodes: bizNodeData[bizNodeDataKey].prjTypeCodes ?? ''
            })

            if (bizNodeData[bizNodeDataKey].subTypes) {
                for (let subTypeKey in bizNodeData[bizNodeDataKey].subTypes) {
                    options.push({
                        label: bizNodeData[bizNodeDataKey].name + '/' + bizNodeData[bizNodeDataKey].subTypes[subTypeKey], value: bizNodeDataKeyValue+'@'+subTypeKey,
                        dpFlag: bizNodeData[bizNodeDataKey].dpFlag ?? '0',
                        prjTypeCodes: bizNodeData[bizNodeDataKey].prjTypeCodes ?? ''
                    })
                }
            }
        }
    }
    return options;
}

export { convertToBizNodeTypeName, convertToDppSubTypeName, bizNodeTypeOptions, subTypeOptions, bizNodeData }
